import { render } from "./DeleteFlowModal.vue?vue&type=template&id=2cb4c290"
import script from "./DeleteFlowModal.vue?vue&type=script&lang=js"
export * from "./DeleteFlowModal.vue?vue&type=script&lang=js"

import "./DeleteFlowModal.vue?vue&type=style&index=0&id=2cb4c290&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QForm,QInput});
